import { render, staticRenderFns } from "./campaignMarketing.vue?vue&type=template&id=b7be4292&scoped=true&"
import script from "./campaignMarketing.vue?vue&type=script&lang=js&"
export * from "./campaignMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7be4292",
  null
  
)

export default component.exports